import styled from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import Button from '../../../components/Button';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modals';
import {
  DASHBOARD,
  EVENT_DEPOSIT_MODAL_OPENED,
  EVENT_WITHDRAW_MODAL_OPENED,
  sendEvent,
} from '../../../common/analytics';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
`;

const WithdrawOrDeposit = ({ onClose }) => {
  const dispatch = useDispatch();

  return (
    <StyledModal onClose={onClose}>
      <ContentContainer>
        <ParagraphLargeText style={{ textAlign: 'center' }}>
          What would you like to do?
        </ParagraphLargeText>
        <ButtonContainer>
          <Button
            fullWidth
            onClick={async () => {
              sendEvent(EVENT_DEPOSIT_MODAL_OPENED, {
                from: DASHBOARD,
              });
              dispatch(
                openModal({
                  name: 'addFunds',
                  props: { showBackButton: true },
                }),
              );
            }}
          >
            Deposit
          </Button>
          <Button
            variant='secondary'
            fullWidth
            onClick={async () => {
              sendEvent(EVENT_WITHDRAW_MODAL_OPENED, {
                from: DASHBOARD,
              });
              dispatch(
                openModal({
                  name: 'withdrawFunds',
                  props: { showBackButton: true },
                }),
              );
            }}
          >
            Withdraw
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </StyledModal>
  );
};

export default WithdrawOrDeposit;
